import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";
import DeparturesForm from "./despartures-form";
import './departures.css';

function Departures() {
    const [masterValue, setMasterValue] = useState('');
    const [masterData, setMasterData] = useState(null);
    const [view, setView] = useState('input');
    const [error, setError] = useState('');
    const [flight, setFlight] = useState('');
    const [year, setYear] = useState(new Date().getFullYear().toString());
    const [flightData, setFlightData] = useState(null);

    const simulatedFlights = [
        {
            flight: "AM0123/25MAY",
            year: "2025",
            cargo: [
                { awb: "139-46289876", piezas: 3, peso: 37.8 },
                { awb: "139-46219855", piezas: 16, peso: 459 },
            ]
        },
        {
            flight: "AM0456/13APR",
            year: "2025",
            cargo: []
        },
        {
            flight: "AM0089/09JUN",
            year: "2024",
            cargo: [
                { awb: "139-88888888", piezas: 5, peso: 220 }
            ]
        }
    ];

    const formatFlight = (value) => {
        const regex = /^([A-Z]{2})(\d{1,4})\/(\d{2})([A-Z]{3})$/i;
        const match = value.toUpperCase().match(regex);

        if (!match) return value.toUpperCase(); // si no matchea, solo convierte a mayúsculas

        const [, airline, number, day, month] = match;
        const paddedNumber = number.padStart(4, '0');
        return `${airline}${paddedNumber}/${day}${month.toUpperCase()}`;
    };

    const handleInputChange = (e) => {
        const input = e.target.value;
        const formatted = formatFlight(input);
        setFlight(formatted);

        if (error) setError('');
    };

    const generateYears = () => {
        const startYear = 2019;
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;
        const years = [];

        for (let y = startYear; y <= nextYear; y++) {
            years.push(y.toString());
        }

        return years;
    };

    const handleYearChange = (e) => {
        setYear(e.target.value);
    };

    const handleSearch = () => {
        if (!flight.trim()) { 
            setError("Este campo es obligatorio");
            return;
        }

        const foundFlight = simulatedFlights.find(f =>
            f.flight.toLowerCase() === flight.toLowerCase() && f.year === year
        );

        const cargo = foundFlight?.cargo || [];

        // Simulación de envío al backend: se crea un array con los datos
        const requestData = [{ flight, year }];
        console.log("Simulando envío al backend:", requestData);

        if (cargo.length === 0) {
            Swal.fire({
                title: "",
                html: `
                    <div style="background-color: #020C41; color: white; padding: 10px; font-size: 1rem; font-weight: bold; text-align: left">
                        Carga actual del vuelo ${flight.toUpperCase()}
                    </div>
                    <div style="padding: 10px;">
                    <div class="alert alert-danger text-start">
                        <p>No hay carga en este vuelo</p>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Continuar",
                cancelButtonText: "Cerrar",
                customClass: {
                    confirmButton: 'btn-amc-blue',
                    cancelButton: 'btn-amc-pink'
                },
                //buttonsStyling: false,
                reverseButtons: true
            }).then((result) => {
                    if (result.isConfirmed) {
                        // alert(`Abrir vista de carga para el vuelo ${flight.toUpperCase()} del año ${year}`);
                        setView("departuresForm");
                        setFlightData({ flight, year });
                    }
            });
        } else {

            let tableHTML = `
                <div style="background-color: #020C41; color: white; padding: 10px; font-size: 1rem; font-weight: bold; text-align: left">
                        Carga actual del vuelo ${flight.toUpperCase()}
                    </div>
                <div style="padding: 10px;">
                <table class="table table-striped mt-3" style="width:100%; text-align:left; border-collapse: collapse;">
                    <thead>
                        <tr>
                            <th style="background-color: #020C41; color: white">AWB</th>
                            <th style="background-color: #020C41; color: white">Piezas</th>
                            <th style="background-color: #020C41; color: white">Peso</th>
                        </tr>
                    </thead>
                    <tbody class="text-center">
            `;

            cargo.forEach(row => {
                tableHTML += `
                    <tr>
                        <td>${row.awb}</td>
                        <td>${row.piezas}</td>
                        <td>${row.peso}</td>
                    </tr>
                `;
            });

            tableHTML += `
                    </tbody>
                </table>
            `;

            Swal.fire({
                title: "",
                html: tableHTML,
                width: 600,
                showCancelButton: true,
                confirmButtonText: "Continuar",
                cancelButtonText: "Cerrar",
                customClass: {
                    confirmButton: 'btn-amc-blue',
                    cancelButton: 'btn-amc-pink'
                },
                //buttonsStyling: false, // importante para que tus clases no se sobrescriban
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    // alert(`Abrir vista de carga para el vuelo ${flight.toUpperCase()} del año ${year}`);
                    setView("departuresForm");
                    setFlightData({ flight, year });
                }
            });
        }
    };

    return(
        <>
            <Helmet>
                <title>Horus | Salidas</title>
            </Helmet>
            <ScrollToTop />
            <div className="container-fluid">
                {view === 'input' && (
                <div className="row justify-content-center">
                    <div className="col-3">
                        <label for="inputMaster" class="amc-label">Vuelo</label>
                        <input 
                            type="text"
                            class="form-control"
                            id="name_flight"
                            value={flight}
                            onChange={handleInputChange}
                        />
                        {error && <small className="text-danger">{error}</small>}
                    </div>
                    <div className="col-3">
                        <label for="inputSelect" class="amc-label">Año</label>
                        <select 
                            className="form-select" 
                            name="year" 
                            id="year"
                            value={year}
                            onChange={handleYearChange}
                        >
                            {generateYears().map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </select>

                        <div className="btns mt-3 d-flex justify-content-end gap-3">
                            <button className='btnn' onClick={handleSearch} >Buscar</button>
                        </div>
                    </div>
                </div>
                )}

                {view === 'departuresForm' && <DeparturesForm flightData={flightData} />}
                {/* {view === 'form' && <CaptureForm masterNumber={masterValue} />} */}
            </div>
        </>
    );
}

export default Departures;